
import { defineComponent } from 'vue'
import { useAclModule } from '@/modules/acl'

export default defineComponent({
    name: 'member-form-field-role',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        label: {
            type: String,
            default: 'Role'
        }
    },
    setup () {
        const { roles } = useAclModule()

        const rolesOptions = roles.value.map(role => {
            return {
                value: role.role,
                label: 'Self-service user'
            }
        })

        return {
            rolesOptions
        }
    }
})
